import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import MiniCartQuantity from "../mini-cart/mini-cart-content/mini-cart-quantity";

export default function SwatchProductActions({
  item,
  limitEach,
  onError = () => {},
  onAfterAdd = () => {},
  onAfterRemove = () => {},
  classPrefix,
  variantId,
  removeButtonClasses,
  addButtonClasses,
  addToCartText,
  removeFromCartText,
  swatchType,
  showWarning,
  removeAction,
}) {
  const handleAtcClick = () => {
    window.addToCart(
      {
        id: variantId,
        quantity: 1,
        properties: {
          _is_swatch: "true",
          _swatch_type: swatchType,
        },
      },
      {
        onError,
        onAfterAdd,
      },
    );
  };

  const handleRemoveClick = () => {
    if (removeAction) {
      removeAction();
      return;
    }

    window.updateCart(
      { updates: { [item.id]: 0 } },
      { onAfterAdd: onAfterRemove },
    );
  };

  return (
    <>
      <div className={`${classPrefix}__product-actions`}>
        {item && limitEach > 1 && (
          <MiniCartQuantity item={item} max={limitEach} />
        )}
        {item ? (
          <button
            type="button"
            className={`${removeButtonClasses} ${classPrefix}__remove`}
            onClick={handleRemoveClick}
          >
            {removeFromCartText}
          </button>
        ) : (
          <button
            type="button"
            className={`${addButtonClasses} ${classPrefix}__add-to-cart`}
            onClick={handleAtcClick}
          >
            {addToCartText}
          </button>
        )}
      </div>
    </>
  );
}
